// Recommended channel artwork (creator profile picture + channel banner).
// Shown beside each upload field as guidance only — picks are NOT validated
// against it, so a creator can attach any image.

export const CHANNEL_ARTWORK_SPECS = {
  profile: {
    ratioLabel: "1:1 square",
    recommended: "800 × 800 px",
    minimum: "400 × 400",
    maxSize: "2 MB",
  },
  banner: {
    ratioLabel: "16:9",
    recommended: "1920 × 1080 px",
    minimum: "1280 × 720",
    maxSize: "5 MB",
  },
};

// One-line recommendation text for display beside an upload field.
export function describeArtworkSpec(type) {
  const s = CHANNEL_ARTWORK_SPECS[type];
  return `Recommended: ${s.ratioLabel} · ${s.recommended} (min ${s.minimum}) · JPG or PNG · up to ${s.maxSize}`;
}

// The same recommendation split into two short lines, for narrow spots.
export function describeArtworkSpecLines(type) {
  const s = CHANNEL_ARTWORK_SPECS[type];
  return [
    `Recommended: ${s.ratioLabel} · ${s.recommended}`,
    `Min ${s.minimum} · JPG or PNG · up to ${s.maxSize}`,
  ];
}
